module.exports = __webpack_public_path__ + "img/stickers_0008_dancer.b08d8ad7.png";